// ============================================
// MENU & PRODUCT DATA
// Real menu from Indian Street Food & Co
// Source: https://indianstreetfood.nemtakeaway.no/order.php
// Images: Real CDN images from nemtakeaway.dk
// ============================================

// CDN base URL for menu images
const CDN_BASE = 'https://cdn.nemtakeaway.dk/site/upload/images/xl';

export const menuCategories = [
  { id: 'small-plates', name: 'Small Plates', nameNo: 'Small Plates', nameSe: 'Smårätter', sortOrder: 1, description: 'Street food favorites to start' },
  { id: 'dum-biryani', name: 'Dum Biryani', nameNo: 'Dum Biryani', nameSe: 'Dum Biryani', sortOrder: 2, description: 'Flavoured Basmati rice with choice of protein & whole masala mix' },
  { id: 'kathi-rolls', name: 'Kathi Rolls', nameNo: 'Kathi Rolls', nameSe: 'Kathi Rolls', sortOrder: 3, description: 'Indian flat bread rolls with raw food mix, mint and pomegranate seeds' },
  { id: 'roadside-curries', name: 'Roadside Curries', nameNo: 'Roadside Curries', nameSe: 'Curries', sortOrder: 4, description: 'Authentic Indian curries' },
  { id: 'from-the-grill', name: 'From the Grill', nameNo: 'Fra Grillen', nameSe: 'Från Grillen', sortOrder: 5, description: 'Tandoor-grilled specialties' },
  { id: 'breads', name: 'Breads', nameNo: 'Brød', nameSe: 'Bröd', sortOrder: 6, description: 'Freshly baked Indian breads' },
  { id: 'extras', name: 'Extras', nameNo: 'Tilbehør', nameSe: 'Tillbehör', sortOrder: 7, description: 'Sides and accompaniments' },
  { id: 'sweets', name: 'Sweets', nameNo: 'Søtt', nameSe: 'Sött', sortOrder: 8, description: 'Traditional Indian desserts' },
  { id: 'kids', name: 'Kids', nameNo: 'Barn', nameSe: 'Barn', sortOrder: 9, description: 'For our younger guests' },
  { id: 'beverages', name: 'Beverages', nameNo: 'Drikke', nameSe: 'Drycker', sortOrder: 10, description: 'Drinks and refreshments' },
];

export const menuItems = [
  // ========== SMALL PLATES ==========
  {
    id: 'street-samosas',
    itemNumber: '1',
    name: 'Street Samosas',
    nameNo: 'Street Samosas',
    description: 'Dekonstruerte grønnsakssamosaer, kikerter og et hint av tamarindchutney med granateplefrø.',
    descriptionEn: 'Deconstructed vegetable samosas, chickpeas and a hint of tamarind chutney with pomegranate seeds.',
    category: 'small-plates',
    vatCategory: 'food',
    prices: { NOK: 149, SEK: 149 },
    discountedPrices: { NOK: 126.65, SEK: 126.65 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['gluten', 'dairy', 'legumes'],
    allergenCodes: ['LINSEMEL', 'M', 'H', 'G', 'V'],
    preparationTime: 10,
    isAvailable: true,
    image: `${CDN_BASE}/284077.png`,
  },
  {
    id: 'aloo-tikki-papdi-chaat',
    itemNumber: '2',
    name: 'Aloo Tikki Papdi Chaat',
    nameNo: 'Aloo Tikki Papdi Chaat',
    description: 'Potetkaker fylt med krydrede linser, hvetesnacks og chutneyer.',
    descriptionEn: 'Potato cakes filled with spiced lentils, wheat snacks and chutneys.',
    category: 'small-plates',
    vatCategory: 'food',
    prices: { NOK: 145, SEK: 145 },
    discountedPrices: { NOK: 123.25, SEK: 123.25 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['gluten', 'dairy', 'legumes'],
    allergenCodes: ['G', 'M', 'V', 'H'],
    preparationTime: 8,
    isAvailable: true,
    image: `${CDN_BASE}/284031.png`,
  },
  {
    id: 'crispy-chili-chicken',
    itemNumber: '3',
    name: 'Crispy Chili Chicken/Paneer',
    nameNo: 'Crispy Chili Chicken/Paneer',
    description: 'Sprøstekt kylling eller paneer i indisk-kinesisk saus.',
    descriptionEn: 'Crispy fried chicken or paneer in Indo-Chinese sauce.',
    category: 'small-plates',
    vatCategory: 'food',
    prices: { NOK: 165, SEK: 165 },
    discountedPrices: { NOK: 140.25, SEK: 140.25 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: false,
    hasVegetarianOption: true,
    allergens: ['dairy', 'soy', 'sesame'],
    allergenCodes: ['V', 'M', 'SO', 'SES'],
    preparationTime: 12,
    isAvailable: true,
    image: `${CDN_BASE}/284033.png`,
  },
  {
    id: 'kolkata-dahi-puri',
    itemNumber: '4',
    name: 'Kolkata Dahi Puri',
    nameNo: 'Kolkata Dahi Puri',
    description: 'Sprø boller fylt med kikerter, krydret vann og søt yoghurt.',
    descriptionEn: 'Crispy balls filled with chickpeas, spiced water and sweet yogurt.',
    category: 'small-plates',
    vatCategory: 'food',
    prices: { NOK: 129, SEK: 129 },
    discountedPrices: { NOK: 109.65, SEK: 109.65 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['gluten', 'dairy'],
    allergenCodes: ['V', 'G'],
    preparationTime: 6,
    isAvailable: true,
    image: `${CDN_BASE}/284035.png`,
  },
  {
    id: 'veg-seekh-kebabs',
    itemNumber: '5',
    name: 'All Greens Veg Seekh Kebabs',
    nameNo: 'All Greens Veg Seekh Kebabs',
    description: 'Grillede kebaber av lokale grønnsaker tilberedt i tandoor.',
    descriptionEn: 'Grilled kebabs of local vegetables prepared in tandoor.',
    category: 'small-plates',
    vatCategory: 'food',
    prices: { NOK: 145, SEK: 145 },
    discountedPrices: { NOK: 123.25, SEK: 123.25 },
    isVegetarian: true,
    isVegan: true,
    isGlutenFree: false,
    allergens: ['gluten'],
    allergenCodes: ['V', 'G'],
    preparationTime: 12,
    isAvailable: true,
    image: `${CDN_BASE}/284077.png`,
  },
  {
    id: 'manchurian-chicken-momos',
    itemNumber: '6',
    name: 'Manchurian Chicken Momos',
    nameNo: 'Manchurian Chicken Momos',
    description: 'Sprøstekte kyllingdumplings i Manchurian-saus.',
    descriptionEn: 'Crispy fried chicken dumplings in Manchurian sauce.',
    category: 'small-plates',
    vatCategory: 'food',
    prices: { NOK: 165, SEK: 165 },
    discountedPrices: { NOK: 140.25, SEK: 140.25 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['gluten', 'legumes', 'soy', 'sesame'],
    allergenCodes: ['G', 'H', 'SO', 'SES'],
    preparationTime: 12,
    isAvailable: true,
    image: `${CDN_BASE}/284033.png`,
  },
  {
    id: 'crispy-honey-cauliflower',
    itemNumber: '7',
    name: 'Crispy Honey Cauliflower',
    nameNo: 'Crispy Honey Cauliflower',
    description: 'Battered fried crispy cauliflower in honey and chili sauce.',
    descriptionEn: 'Battered fried crispy cauliflower in honey and chili sauce.',
    category: 'small-plates',
    vatCategory: 'food',
    prices: { NOK: 155, SEK: 155 },
    discountedPrices: { NOK: 131.75, SEK: 131.75 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['sesame'],
    allergenCodes: ['V', 'SES'],
    preparationTime: 10,
    isAvailable: true,
    image: `${CDN_BASE}/284033.png`,
  },
  {
    id: 'tandoori-chicken-wings',
    itemNumber: '8',
    name: 'Tandoori Chicken Wings',
    nameNo: 'Tandoori Chicken Wings',
    description: 'Krydret tandoorikyllingvinger servert med kashmirchilimajones.',
    descriptionEn: 'Spiced tandoori chicken wings served with kashmiri chili mayonnaise.',
    category: 'small-plates',
    vatCategory: 'food',
    prices: { NOK: 159, SEK: 159 },
    discountedPrices: { NOK: 135.15, SEK: 135.15 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['gluten', 'soy', 'sesame', 'egg'],
    allergenCodes: ['G', 'SO', 'SES', 'E'],
    preparationTime: 15,
    isAvailable: true,
    image: `${CDN_BASE}/284097.png`,
  },

  // ========== DUM BIRYANI ==========
  {
    id: 'dum-biryani-chicken',
    itemNumber: '12',
    name: 'Dum Biryani Chicken',
    nameNo: 'Dum Biryani Kylling',
    description: 'Aromatisk basmatiris med kylling og autentisk krydder.',
    descriptionEn: 'Aromatic basmati rice with chicken and authentic spices.',
    category: 'dum-biryani',
    vatCategory: 'food',
    prices: { NOK: 275, SEK: 275 },
    discountedPrices: { NOK: 233.75, SEK: 233.75 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    allergenCodes: ['M'],
    preparationTime: 18,
    isAvailable: true,
    isSignatureDish: true,
    image: `${CDN_BASE}/284037.png`,
  },
  {
    id: 'dum-biryani-lamb',
    itemNumber: '13',
    name: 'Dum Biryani Lamb',
    nameNo: 'Dum Biryani Lam',
    description: 'Lammebiryani med aromatiske krydder.',
    descriptionEn: 'Lamb biryani with aromatic spices.',
    category: 'dum-biryani',
    vatCategory: 'food',
    prices: { NOK: 275, SEK: 275 },
    discountedPrices: { NOK: 233.75, SEK: 233.75 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    allergenCodes: ['M'],
    preparationTime: 20,
    isAvailable: true,
    image: `${CDN_BASE}/284041.png`,
  },
  {
    id: 'dum-biryani-jackfruit',
    itemNumber: '14',
    name: 'Dum Biryani Jackfruit',
    nameNo: 'Dum Biryani Jackfruit',
    description: 'Biryani med jackfruit for vegetardigg.',
    descriptionEn: 'Biryani with jackfruit for vegetarians.',
    category: 'dum-biryani',
    vatCategory: 'food',
    prices: { NOK: 275, SEK: 275 },
    discountedPrices: { NOK: 233.75, SEK: 233.75 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    allergenCodes: ['M', 'V'],
    preparationTime: 18,
    isAvailable: true,
    image: `${CDN_BASE}/284039.png`,
  },

  // ========== KATHI ROLLS ==========
  {
    id: 'kathi-roll-chicken',
    itemNumber: '15',
    name: 'Grilled Chicken Tikkas Roll',
    nameNo: 'Grillet Kyllingtikka Rull',
    description: 'Indisk flatbrødrull med saftig marinert kylling, servert med korianderyoghurt-dip.',
    descriptionEn: 'Indian flat bread roll with juicy marinated chicken, served with coriander yogurt dip.',
    category: 'kathi-rolls',
    vatCategory: 'food',
    prices: { NOK: 205, SEK: 205 },
    discountedPrices: { NOK: 174.25, SEK: 174.25 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['dairy', 'gluten', 'egg'],
    allergenCodes: ['M', 'G', 'E'],
    preparationTime: 12,
    isAvailable: true,
    image: `${CDN_BASE}/284085.png`,
  },
  {
    id: 'kathi-roll-paneer',
    itemNumber: '16',
    name: 'Grilled Paneer Cheese Roll',
    nameNo: 'Grillet Paneerost Rull',
    description: 'Indisk flatbrødrull med paneer i krydret mix av grønnsaker, servert med korianderyoghurt-dip.',
    descriptionEn: 'Indian flat bread roll with paneer in spiced vegetable mix, served with coriander yogurt dip.',
    category: 'kathi-rolls',
    vatCategory: 'food',
    prices: { NOK: 205, SEK: 205 },
    discountedPrices: { NOK: 174.25, SEK: 174.25 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['dairy', 'gluten', 'egg'],
    allergenCodes: ['M', 'G', 'E'],
    preparationTime: 12,
    isAvailable: true,
    image: `${CDN_BASE}/284085.png`,
  },
  {
    id: 'kathi-roll-veggie',
    itemNumber: '17',
    name: 'Veggie Samosas Roll',
    nameNo: 'Veggie Samosa Rull',
    description: 'Indisk flatbrødrull med rå grønnsaker, mynte, granateplefrø, servert med korianderyoghurt-dip.',
    descriptionEn: 'Indian flat bread roll with raw vegetables, mint, pomegranate seeds, served with coriander yogurt dip.',
    category: 'kathi-rolls',
    vatCategory: 'food',
    prices: { NOK: 205, SEK: 205 },
    discountedPrices: { NOK: 174.25, SEK: 174.25 },
    isVegetarian: true,
    isVegan: false,
    hasVeganOption: true,
    isGlutenFree: false,
    allergens: ['dairy', 'gluten', 'egg'],
    allergenCodes: ['M', 'G', 'E'],
    preparationTime: 10,
    isAvailable: true,
    image: `${CDN_BASE}/284085.png`,
  },

  // ========== ROADSIDE CURRIES ==========
  {
    id: 'delhi-butter-chicken',
    itemNumber: '18',
    name: 'Smoky Delhi Style Butter Chicken',
    nameNo: 'Røkt Delhi Style Smørkylling',
    description: 'Røkt smørkylling fra Delhi i tomat-ingefærsaus.',
    descriptionEn: 'Smoky butter chicken from Delhi in tomato-ginger sauce.',
    category: 'roadside-curries',
    vatCategory: 'food',
    prices: { NOK: 275, SEK: 275 },
    discountedPrices: { NOK: 233.75, SEK: 233.75 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    allergenCodes: ['M'],
    preparationTime: 15,
    isAvailable: true,
    isSignatureDish: true,
    image: `${CDN_BASE}/284047.png`,
  },
  {
    id: 'chicken-tikka-masala',
    itemNumber: '19',
    name: 'ISF&CO Chicken Tikka Masala',
    nameNo: 'ISF&CO Chicken Tikka Masala',
    description: 'Tikka masala fra ISF&Co: Grillet kylling i husets kryddersaus med bukkehornkløver.',
    descriptionEn: 'Tikka masala from ISF&Co: Grilled chicken in house spice sauce with fenugreek.',
    category: 'roadside-curries',
    vatCategory: 'food',
    prices: { NOK: 275, SEK: 275 },
    discountedPrices: { NOK: 233.75, SEK: 233.75 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    allergenCodes: ['M'],
    preparationTime: 15,
    isAvailable: true,
    isSignatureDish: true,
    image: `${CDN_BASE}/284047.png`,
  },
  {
    id: 'lucknowi-nalli-gosht',
    itemNumber: '20',
    name: 'Lucknowi Nalli Gosht',
    nameNo: 'Lucknowi Nalli Gosht',
    description: 'Lammeknokegryte fra Lucknow, langtidskokt med krydder og urter.',
    descriptionEn: 'Lamb shank stew from Lucknow, slow-cooked with spices and herbs.',
    category: 'roadside-curries',
    vatCategory: 'food',
    prices: { NOK: 305, SEK: 305 },
    discountedPrices: { NOK: 259.25, SEK: 259.25 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    allergenCodes: ['M'],
    preparationTime: 20,
    isAvailable: true,
    image: `${CDN_BASE}/284051.png`,
  },
  {
    id: 'natu-kozi',
    itemNumber: '21',
    name: 'Natu Kozi',
    nameNo: 'Natu Kozi',
    description: 'Sørindisk kokoskylling: Grillet kylling i kokos- og løksaus med karri og sennepsfrø.',
    descriptionEn: 'South Indian coconut chicken: Grilled chicken in coconut and onion sauce with curry and mustard seeds.',
    category: 'roadside-curries',
    vatCategory: 'food',
    prices: { NOK: 260, SEK: 260 },
    discountedPrices: { NOK: 221.00, SEK: 221.00 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy', 'mustard'],
    allergenCodes: ['M', 'SEN'],
    preparationTime: 15,
    isAvailable: true,
    image: `${CDN_BASE}/284047.png`,
  },
  {
    id: 'lamb-laal-maas',
    itemNumber: '22',
    name: 'Lamb Laal Maas',
    nameNo: 'Lamb Laal Maas',
    description: 'Sterk rød lammegryte med tomat og rød chili.',
    descriptionEn: 'Spicy red lamb stew with tomato and red chili.',
    category: 'roadside-curries',
    vatCategory: 'food',
    prices: { NOK: 265, SEK: 265 },
    discountedPrices: { NOK: 225.25, SEK: 225.25 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: true,
    spiceLevel: 'hot',
    allergens: ['dairy'],
    allergenCodes: ['M'],
    preparationTime: 18,
    isAvailable: true,
    image: `${CDN_BASE}/284051.png`,
  },
  {
    id: 'pindi-chole',
    itemNumber: '23',
    name: 'Pindi Chole Amritsari',
    nameNo: 'Pindi Chole Amritsari',
    description: 'Amritsar-style krydret kikertkarri.',
    descriptionEn: 'Amritsar-style spiced chickpea curry.',
    category: 'roadside-curries',
    vatCategory: 'food',
    prices: { NOK: 225, SEK: 225 },
    discountedPrices: { NOK: 191.25, SEK: 191.25 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    allergenCodes: ['M', 'V'],
    preparationTime: 12,
    isAvailable: true,
    image: `${CDN_BASE}/284047.png`,
  },
  {
    id: 'hara-bhara-paneer-kofta',
    itemNumber: '24',
    name: 'Hara Bhara Paneer Kofta',
    nameNo: 'Hara Bhara Paneer Kofta',
    description: 'Paneerkofta i grønn saus: Vegetarboller i spinat- og tomatsaus.',
    descriptionEn: 'Paneer kofta in green sauce: Vegetarian balls in spinach and tomato sauce.',
    category: 'roadside-curries',
    vatCategory: 'food',
    prices: { NOK: 255, SEK: 255 },
    discountedPrices: { NOK: 216.75, SEK: 216.75 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['dairy', 'gluten'],
    allergenCodes: ['M', 'G', 'V'],
    preparationTime: 14,
    isAvailable: true,
    image: `${CDN_BASE}/284059.png`,
  },
  {
    id: 'dal-makhani',
    itemNumber: '25',
    name: 'Dal Makhani Bukhara',
    nameNo: 'Dal Makhani Bukhara',
    description: 'Bukhari Dal Makhani: Langtidskokte svarte linser i tomatsaus.',
    descriptionEn: 'Bukhari Dal Makhani: Slow-cooked black lentils in tomato sauce.',
    category: 'roadside-curries',
    vatCategory: 'food',
    prices: { NOK: 215, SEK: 215 },
    discountedPrices: { NOK: 182.75, SEK: 182.75 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    allergenCodes: ['M', 'V'],
    preparationTime: 12,
    isAvailable: true,
    isSignatureDish: true,
    image: `${CDN_BASE}/284047.png`,
  },
  {
    id: 'bharwan-paneer-papad',
    itemNumber: '26',
    name: 'Bharwan Paneer Papad Masala',
    nameNo: 'Bharwan Paneer Papad Masala',
    description: 'Sprø fylt paneer i kremet masalasaus med papadamsmuler.',
    descriptionEn: 'Crispy stuffed paneer in creamy masala sauce with papadum crumbs.',
    category: 'roadside-curries',
    vatCategory: 'food',
    prices: { NOK: 250, SEK: 250 },
    discountedPrices: { NOK: 212.50, SEK: 212.50 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    allergenCodes: ['M', 'V'],
    preparationTime: 14,
    isAvailable: true,
    image: `${CDN_BASE}/284059.png`,
  },
  {
    id: 'paneer-tikka-makhani',
    itemNumber: '27',
    name: 'Paneer Tikka Makhani',
    nameNo: 'Paneer Tikka Makhani',
    description: 'Grilled paneer cheese served in tomato sizzler sauce.',
    descriptionEn: 'Grilled paneer cheese served in tomato sizzler sauce.',
    category: 'roadside-curries',
    vatCategory: 'food',
    prices: { NOK: 265, SEK: 265 },
    discountedPrices: { NOK: 225.25, SEK: 225.25 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    allergenCodes: ['M', 'V'],
    preparationTime: 14,
    isAvailable: true,
    image: `${CDN_BASE}/284059.png`,
  },
  {
    id: 'seasonal-masala-veggies',
    itemNumber: '28',
    name: 'Seasonal Masala Veggies',
    nameNo: 'Sesonggrønnsaker Masala',
    description: 'Seasonal veggies tossed in tomato, ginger and garam masala.',
    descriptionEn: 'Seasonal veggies tossed in tomato, ginger and garam masala.',
    category: 'roadside-curries',
    vatCategory: 'food',
    prices: { NOK: 265, SEK: 265 },
    discountedPrices: { NOK: 225.25, SEK: 225.25 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    allergenCodes: ['M', 'V'],
    preparationTime: 12,
    isAvailable: true,
    image: `${CDN_BASE}/284047.png`,
  },
  {
    id: 'kerala-prawn-curry',
    itemNumber: '29',
    name: 'Kerala Prawn Curry',
    nameNo: 'Kerala Rekekarri',
    description: 'Kongerekscurry med kokos, ingefær, karri-blader og frisk koriander.',
    descriptionEn: 'King prawn curry with coconut, ginger, curry leaves and fresh coriander.',
    category: 'roadside-curries',
    vatCategory: 'food',
    prices: { NOK: 275, SEK: 275 },
    discountedPrices: { NOK: 233.75, SEK: 233.75 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy', 'sesame', 'shellfish'],
    allergenCodes: ['M', 'SES', 'S'],
    preparationTime: 15,
    isAvailable: true,
    image: `${CDN_BASE}/284053.png`,
  },
  {
    id: 'dal-tadka',
    itemNumber: '30',
    name: 'Dal Tadka',
    nameNo: 'Dal Tadka',
    description: 'Gul linsestuing med indiske krydder.',
    descriptionEn: 'Yellow lentil stew with Indian spices.',
    category: 'roadside-curries',
    vatCategory: 'food',
    prices: { NOK: 210, SEK: 210 },
    discountedPrices: { NOK: 178.50, SEK: 178.50 },
    isVegetarian: true,
    isVegan: true,
    isGlutenFree: true,
    allergens: [],
    allergenCodes: ['V'],
    preparationTime: 10,
    isAvailable: true,
    image: `${CDN_BASE}/284047.png`,
  },

  // ========== FROM THE GRILL ==========
  {
    id: 'kalmi-chicken-tikkas',
    itemNumber: '31',
    name: 'Kalmi Chicken Tikkas',
    nameNo: 'Kalmi Kyllingtikka',
    description: 'Grillet kyllinglårfilet marinert i cashew- og ostemasala, servert med myntechutney.',
    descriptionEn: 'Grilled chicken thigh fillet marinated in cashew and cheese masala, served with mint chutney.',
    category: 'from-the-grill',
    vatCategory: 'food',
    prices: { NOK: 285, SEK: 285 },
    discountedPrices: { NOK: 242.25, SEK: 242.25 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy', 'nuts'],
    allergenCodes: ['M', 'N'],
    preparationTime: 18,
    isAvailable: true,
    image: `${CDN_BASE}/284057.png`,
  },
  {
    id: 'harissa-paneer-tikka',
    itemNumber: '32',
    name: 'Harissa Paneer Tikka',
    nameNo: 'Harissa Paneer Tikka',
    description: 'Grillet indisk ostetikka krydret med harissa og garam masala, servert med paprika og løk.',
    descriptionEn: 'Grilled Indian cheese tikka spiced with harissa and garam masala, served with peppers and onion.',
    category: 'from-the-grill',
    vatCategory: 'food',
    prices: { NOK: 275, SEK: 275 },
    discountedPrices: { NOK: 233.75, SEK: 233.75 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy', 'mustard'],
    allergenCodes: ['V', 'M', 'SEN'],
    preparationTime: 15,
    isAvailable: true,
    image: `${CDN_BASE}/284059.png`,
  },
  {
    id: 'bhatti-da-murg',
    itemNumber: '33',
    name: 'Bhatti Da Murg',
    nameNo: 'Bhatti Da Murg',
    description: 'Grillet kylling marinert i tandoorikrydder og stekt i tandoorovn. Velg mellom lårfilet eller halv kylling.',
    descriptionEn: 'Grilled chicken marinated in tandoori spices and cooked in tandoor oven. Choose between thigh fillet or half chicken.',
    category: 'from-the-grill',
    vatCategory: 'food',
    prices: { NOK: 285, SEK: 285 },
    discountedPrices: { NOK: 242.25, SEK: 242.25 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    allergenCodes: ['M'],
    preparationTime: 20,
    isAvailable: true,
    image: `${CDN_BASE}/284061.png`,
  },
  {
    id: 'old-delhi-seekh-kebabs',
    itemNumber: '34',
    name: 'Old Delhi Style Seekh Kebabs',
    nameNo: 'Old Delhi Style Seekh Kebabs',
    description: 'Kylling marinert i fersk garam masala.',
    descriptionEn: 'Chicken marinated in fresh garam masala.',
    category: 'from-the-grill',
    vatCategory: 'food',
    prices: { NOK: 285, SEK: 285 },
    discountedPrices: { NOK: 242.25, SEK: 242.25 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['legumes'],
    allergenCodes: ['LINSEMEL'],
    preparationTime: 18,
    isAvailable: true,
    image: `${CDN_BASE}/284063.png`,
  },
  {
    id: 'golden-goan-prawns',
    itemNumber: '35',
    name: 'Golden Goan Prawns',
    nameNo: 'Golden Goan Reker',
    description: 'Grillede tigerreker i gul pickles-masala.',
    descriptionEn: 'Grilled tiger prawns in yellow pickle masala.',
    category: 'from-the-grill',
    vatCategory: 'food',
    prices: { NOK: 285, SEK: 285 },
    discountedPrices: { NOK: 242.25, SEK: 242.25 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy', 'sesame', 'shellfish'],
    allergenCodes: ['M', 'SES', 'S'],
    preparationTime: 15,
    isAvailable: true,
    image: `${CDN_BASE}/284053.png`,
  },
  {
    id: 'burra-lamb-chops',
    itemNumber: '36',
    name: 'Burra Lamb Chops',
    nameNo: 'Burra Lammekoteletter',
    description: 'Kullgrillede tandoori lammekoteletter med ISF&Co-masala.',
    descriptionEn: 'Charcoal grilled tandoori lamb chops with ISF&Co masala.',
    category: 'from-the-grill',
    vatCategory: 'food',
    prices: { NOK: 345, SEK: 345 },
    discountedPrices: { NOK: 293.25, SEK: 293.25 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    allergenCodes: ['M'],
    preparationTime: 22,
    isAvailable: true,
    isSignatureDish: true,
    image: `${CDN_BASE}/284065.png`,
  },
  {
    id: 'mixed-grill',
    itemNumber: '37',
    name: 'Mixed Grill',
    nameNo: 'Miks Grill',
    description: 'En miks av kylling seekh-kebaber, tandoori kyllingtikka og grillede reker.',
    descriptionEn: 'A mix of chicken seekh kebabs, tandoori chicken tikka and grilled prawns.',
    category: 'from-the-grill',
    vatCategory: 'food',
    prices: { NOK: 345, SEK: 345 },
    discountedPrices: { NOK: 293.25, SEK: 293.25 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['dairy', 'legumes', 'shellfish', 'sesame'],
    allergenCodes: ['M', 'LINSEMEL', 'S', 'SES'],
    preparationTime: 20,
    isAvailable: true,
    image: `${CDN_BASE}/284067.png`,
  },

  // ========== BREADS ==========
  {
    id: 'plain-naan',
    itemNumber: '38',
    name: 'Plain Naan',
    nameNo: 'Plain Naan',
    description: 'Tradisjonelt indisk brød bakt i tandoor.',
    descriptionEn: 'Traditional Indian bread baked in tandoor.',
    category: 'breads',
    vatCategory: 'food',
    prices: { NOK: 45, SEK: 45 },
    discountedPrices: { NOK: 38.25, SEK: 38.25 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['dairy', 'legumes', 'gluten'],
    allergenCodes: ['M', 'H', 'G'],
    preparationTime: 5,
    isAvailable: true,
    image: `${CDN_BASE}/284091.png`,
  },
  {
    id: 'garlic-herb-naan',
    itemNumber: '39',
    name: 'Garlic And Herb Naan',
    nameNo: 'Hvitløk og Urte Naan',
    description: 'Naan med hvitløk og urter.',
    descriptionEn: 'Naan with garlic and herbs.',
    category: 'breads',
    vatCategory: 'food',
    prices: { NOK: 55, SEK: 55 },
    discountedPrices: { NOK: 46.75, SEK: 46.75 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['dairy', 'legumes', 'gluten'],
    allergenCodes: ['M', 'H', 'G'],
    preparationTime: 5,
    isAvailable: true,
    image: `${CDN_BASE}/284091.png`,
  },
  {
    id: 'vasterbottens-cheese-naan',
    itemNumber: '40',
    name: 'Västerbottens Cheese Naan',
    nameNo: 'Västerbottens Ostenaan',
    description: 'Naan fylt med svensk Västerbottens-ost.',
    descriptionEn: 'Naan stuffed with Swedish Västerbottens cheese.',
    category: 'breads',
    vatCategory: 'food',
    prices: { NOK: 65, SEK: 65 },
    discountedPrices: { NOK: 55.25, SEK: 55.25 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['dairy', 'legumes', 'gluten'],
    allergenCodes: ['M', 'H', 'G'],
    preparationTime: 6,
    isAvailable: true,
    image: `${CDN_BASE}/284091.png`,
  },
  {
    id: 'chapati',
    itemNumber: '41',
    name: 'Chapati',
    nameNo: 'Chapati',
    description: 'Indisk fullkornsflatbrød.',
    descriptionEn: 'Indian whole wheat flatbread.',
    category: 'breads',
    vatCategory: 'food',
    prices: { NOK: 35, SEK: 35 },
    discountedPrices: { NOK: 29.75, SEK: 29.75 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['dairy', 'legumes', 'gluten'],
    allergenCodes: ['M', 'H', 'G'],
    preparationTime: 4,
    isAvailable: true,
    image: `${CDN_BASE}/284025.png`,
  },
  {
    id: 'lachha-parantha',
    itemNumber: '42',
    name: 'Lachha Parantha',
    nameNo: 'Lachha Parantha',
    description: 'Lagdelt smørbrød.',
    descriptionEn: 'Layered buttery bread.',
    category: 'breads',
    vatCategory: 'food',
    prices: { NOK: 49, SEK: 49 },
    discountedPrices: { NOK: 41.65, SEK: 41.65 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['dairy', 'legumes', 'gluten'],
    allergenCodes: ['M', 'H', 'G'],
    preparationTime: 5,
    isAvailable: true,
    image: `${CDN_BASE}/284025.png`,
  },
  {
    id: 'isf-spiced-naan',
    itemNumber: '43',
    name: 'ISF&CO Spiced Naan',
    nameNo: 'ISF&CO Krydret Naan',
    description: 'Signatur krydret naan fra ISF&Co.',
    descriptionEn: 'Signature spiced naan from ISF&Co.',
    category: 'breads',
    vatCategory: 'food',
    prices: { NOK: 69, SEK: 69 },
    discountedPrices: { NOK: 58.65, SEK: 58.65 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['dairy', 'legumes', 'gluten'],
    allergenCodes: ['M', 'H', 'G'],
    preparationTime: 5,
    isAvailable: true,
    image: `${CDN_BASE}/284093.png`,
  },
  {
    id: 'norwegian-brunost-naan',
    itemNumber: '44',
    name: 'Norwegian Brunost Naan',
    nameNo: 'Norsk Brunostnaan',
    description: 'Naan med norsk brunost.',
    descriptionEn: 'Naan with Norwegian brown cheese.',
    category: 'breads',
    vatCategory: 'food',
    prices: { NOK: 75, SEK: 75 },
    discountedPrices: { NOK: 63.75, SEK: 63.75 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['dairy', 'legumes', 'gluten'],
    allergenCodes: ['M', 'H', 'G'],
    preparationTime: 6,
    isAvailable: true,
    isSignatureDish: true,
    image: `${CDN_BASE}/284093.png`,
  },
  {
    id: 'amritsari-kulcha',
    itemNumber: '45',
    name: 'Amritsari Kulcha',
    nameNo: 'Amritsari Kulcha',
    description: 'Fylt brød fra Amritsar.',
    descriptionEn: 'Stuffed bread from Amritsar.',
    category: 'breads',
    vatCategory: 'food',
    prices: { NOK: 75, SEK: 75 },
    discountedPrices: { NOK: 63.75, SEK: 63.75 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
    allergens: ['dairy', 'legumes', 'gluten'],
    allergenCodes: ['M', 'H', 'G'],
    preparationTime: 6,
    isAvailable: true,
    image: `${CDN_BASE}/284093.png`,
  },

  // ========== EXTRAS ==========
  {
    id: 'papadams-chutneys',
    itemNumber: '46',
    name: 'Papadams and Chutneys',
    nameNo: 'Papadams og Chutney',
    description: 'Sprø papadams med utvalgte chutneys.',
    descriptionEn: 'Crispy papadams with assorted chutneys.',
    category: 'extras',
    vatCategory: 'food',
    prices: { NOK: 55, SEK: 55 },
    discountedPrices: { NOK: 46.75, SEK: 46.75 },
    isVegetarian: true,
    isVegan: true,
    isGlutenFree: false,
    allergens: ['legumes'],
    allergenCodes: ['Linsemel'],
    preparationTime: 3,
    isAvailable: true,
    image: `${CDN_BASE}/284077.png`,
  },
  {
    id: 'all-over-india-raita',
    itemNumber: '47',
    name: 'All Over India Raita',
    nameNo: 'All Over India Raita',
    description: 'Avkjølende yoghurtdip med krydder.',
    descriptionEn: 'Cooling yogurt dip with spices.',
    category: 'extras',
    vatCategory: 'food',
    prices: { NOK: 35, SEK: 35 },
    discountedPrices: { NOK: 29.75, SEK: 29.75 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    allergenCodes: ['M'],
    preparationTime: 2,
    isAvailable: true,
    image: `${CDN_BASE}/284095.png`,
  },
  {
    id: 'pickles',
    itemNumber: '48',
    name: 'Pickles',
    nameNo: 'Pickles',
    description: 'Hjemmelagde indiske pickles.',
    descriptionEn: 'Homemade Indian pickles.',
    category: 'extras',
    vatCategory: 'food',
    prices: { NOK: 25, SEK: 25 },
    discountedPrices: { NOK: 21.25, SEK: 21.25 },
    isVegetarian: true,
    isVegan: true,
    isGlutenFree: true,
    allergens: ['sesame', 'mustard'],
    allergenCodes: ['SES', 'SEN'],
    preparationTime: 1,
    isAvailable: true,
    image: `${CDN_BASE}/284095.png`,
  },
  {
    id: 'indian-style-salad',
    itemNumber: '49',
    name: 'Indian Style Salad',
    nameNo: 'Indisk Salat',
    description: 'Løk, tomater, agurk.',
    descriptionEn: 'Onion, tomatoes, cucumber.',
    category: 'extras',
    vatCategory: 'food',
    prices: { NOK: 30, SEK: 30 },
    discountedPrices: { NOK: 25.50, SEK: 25.50 },
    isVegetarian: true,
    isVegan: true,
    isGlutenFree: true,
    allergens: [],
    allergenCodes: ['V'],
    preparationTime: 2,
    isAvailable: true,
    image: `${CDN_BASE}/284095.png`,
  },

  // ========== SWEETS ==========
  {
    id: 'kesar-rasmalai',
    itemNumber: '51',
    name: 'Kesar Rasmalai',
    nameNo: 'Kesar Rasmalai',
    description: 'Hytteost-puff i safran- og kardemommemelk.',
    descriptionEn: 'Cottage cheese puffs in saffron and cardamom milk.',
    category: 'sweets',
    vatCategory: 'food',
    prices: { NOK: 95, SEK: 95 },
    discountedPrices: { NOK: 80.75, SEK: 80.75 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy', 'nuts'],
    allergenCodes: ['M', 'V', 'N'],
    preparationTime: 3,
    isAvailable: true,
    image: `${CDN_BASE}/284087.png`,
  },
  {
    id: 'house-ice-cream',
    itemNumber: '53',
    name: 'Scoops of House Ice Cream',
    nameNo: 'Husets Is',
    description: 'Toppet med ristede nøtter.',
    descriptionEn: 'Topped with roasted nuts.',
    category: 'sweets',
    vatCategory: 'food',
    prices: { NOK: 85, SEK: 85 },
    discountedPrices: { NOK: 72.25, SEK: 72.25 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy', 'egg', 'nuts'],
    allergenCodes: ['M', 'E', 'N'],
    preparationTime: 2,
    isAvailable: false, // Utsolgt
    image: `${CDN_BASE}/284087.png`,
  },

  // ========== KIDS ==========
  {
    id: 'kids-kalmi-chicken',
    itemNumber: '54',
    name: 'Kids Kalmi Chicken Tikkas',
    nameNo: 'Barn Kalmi Kyllingtikka',
    description: 'Servert med ris og saus.',
    descriptionEn: 'Served with rice and sauce.',
    category: 'kids',
    vatCategory: 'food',
    prices: { NOK: 155, SEK: 155 },
    discountedPrices: { NOK: 131.75, SEK: 131.75 },
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    allergenCodes: ['M'],
    preparationTime: 12,
    isAvailable: true,
    image: `${CDN_BASE}/284097.png`,
  },

  // ========== BEVERAGES ==========
  {
    id: 'mango-lassi',
    name: 'Mango Lassi',
    nameNo: 'Mango Lassi',
    description: 'Kremete yoghurtdrikk med mango.',
    descriptionEn: 'Creamy yogurt drink with mango.',
    category: 'beverages',
    vatCategory: 'beverages',
    prices: { NOK: 65, SEK: 65 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    preparationTime: 3,
    isAvailable: true,
    image: `${CDN_BASE}/284095.png`,
  },
  {
    id: 'masala-chai',
    name: 'Masala Chai',
    nameNo: 'Masala Chai',
    description: 'Krydret indisk te med melk.',
    descriptionEn: 'Spiced Indian tea with milk.',
    category: 'beverages',
    vatCategory: 'beverages',
    prices: { NOK: 49, SEK: 49 },
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: true,
    allergens: ['dairy'],
    preparationTime: 4,
    isAvailable: true,
    image: `${CDN_BASE}/284095.png`,
  },
  {
    id: 'soft-drinks',
    name: 'Soft Drinks',
    nameNo: 'Brus',
    description: 'Coca-Cola, Fanta, Sprite, Solo.',
    descriptionEn: 'Coca-Cola, Fanta, Sprite, Solo.',
    category: 'beverages',
    vatCategory: 'beverages',
    prices: { NOK: 45, SEK: 45 },
    isVegetarian: true,
    isVegan: true,
    isGlutenFree: true,
    allergens: [],
    preparationTime: 1,
    isAvailable: true,
    image: `${CDN_BASE}/284095.png`,
  },
  {
    id: 'water',
    name: 'Still/Sparkling Water',
    nameNo: 'Vann',
    description: 'Imsdal eller farris.',
    descriptionEn: 'Still or sparkling water.',
    category: 'beverages',
    vatCategory: 'beverages',
    prices: { NOK: 39, SEK: 39 },
    isVegetarian: true,
    isVegan: true,
    isGlutenFree: true,
    allergens: [],
    preparationTime: 1,
    isAvailable: true,
    image: `${CDN_BASE}/284095.png`,
  },
];

// Helper functions
export const getMenuItemById = (id) => menuItems.find(i => i.id === id);
export const getMenuItemsByCategory = (categoryId) => menuItems.filter(i => i.category === categoryId);
export const getAvailableMenuItems = () => menuItems.filter(i => i.isAvailable);
export const getVegetarianItems = () => menuItems.filter(i => i.isVegetarian);
export const getVeganItems = () => menuItems.filter(i => i.isVegan);
export const getSignatureDishes = () => menuItems.filter(i => i.isSignatureDish);

export const getItemPrice = (item, currency = 'NOK', useDiscount = true) => {
  if (useDiscount && item.discountedPrices) {
    return item.discountedPrices[currency] || item.discountedPrices.NOK;
  }
  return item.prices[currency] || item.prices.NOK;
};

export const getCategoryById = (id) => menuCategories.find(c => c.id === id);

// Allergen code explanations
export const allergenCodes = {
  'G': 'Gluten',
  'M': 'Melk/Dairy',
  'E': 'Egg',
  'S': 'Skalldyr/Shellfish',
  'N': 'Nøtter/Nuts',
  'SO': 'Soya',
  'SES': 'Sesam/Sesame',
  'SEN': 'Sennep/Mustard',
  'H': 'Belgfrukter/Legumes',
  'V': 'Vegetar/Vegetarian',
  'LINSEMEL': 'Linsemel/Lentil flour',
};
